import React, { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { Box as BoxOld, xcss } from '@atlaskit/primitives';
import { cssMap, cx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useVerticalMode } from '../../../controllers/feature-context.tsx';

const listItemStyles = cssMap({
	default: {
		marginTop: token('space.050'),
		marginRight: token('space.050'),
		marginBottom: token('space.050'),
		marginLeft: token('space.050'),
		listStyle: 'none',
	},
	vertical: {
		marginTop: token('space.0'),
		marginBottom: token('space.200'),
		marginLeft: token('space.0'),
		marginRight: token('space.0'),
	},
});

const ListItemChild = ({ children }: { children: ReactNode }): React.JSX.Element => {
	const verticalMode = useVerticalMode();

	if (!fg('list_lovability_improving_filters')) {
		return (
			<BoxOld
				as="li"
				xcss={listItemStylesOld}
				data-vc="jql-builder-basic-list-item-child"
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				testId="jql-builder-basic-refinement-fallback"
			>
				{children}
			</BoxOld>
		);
	}

	return (
		<Box
			as="li"
			xcss={cx(listItemStyles.default, verticalMode && listItemStyles.vertical)}
			data-vc="jql-builder-basic-list-item-child"
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="jql-builder-basic-refinement-fallback"
		>
			{children}
		</Box>
	);
};

export default ListItemChild;

const listItemStylesOld = xcss({
	margin: 'space.050',
	minWidth: 'space.0',
	listStyle: 'none',
});
